<div mat-dialog-title class="customize-display-title">Customize Display</div>
<mat-dialog-content>
  <mat-selection-list [formControl]="optionsListFormField">
    @for (column of columnOptions(); track column) {
      <mat-list-option [selected]="columnSelection.isSelected(column)" togglePosition="before" [value]="column" style="font-size: 14px;">{{column.displayName}}</mat-list-option>
    }
  </mat-selection-list>
</mat-dialog-content>
